<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<ng-container *ngIf="notifications?.length; else noNotificationsTemplate">
    <div class="notifications-list custom-scroll-bar">
        <div *ngFor="let notification of notifications" class="notifications-list_item">
            <a (click)="openProject(notification.projectId)" *ngIf="notification.projectId" class="project-url">{{ notification.text }}</a>

            <ng-container *ngIf="notification.progress">
                <div class="progress-bar-info">
                    <span class="step-name">Step: {{ notification.progress.stepName }}</span>
                    <span>{{ notification.progress.percent | number: '1.0-2' }} %</span>
                </div>
                <mat-progress-bar [value]="notification.progress.percent" mode="determinate"></mat-progress-bar>
            </ng-container>
        </div>
    </div>
</ng-container>

<ng-template #noNotificationsTemplate><span class="no-notifications-text">No notifications to show</span></ng-template>
